import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-16b68a27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "addAppQuestionPage" }

import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import {
  addAndUpdateAppQuestionAndOptionUsingPost,
  getAppQuestionAndOptionUsingGet,
} from "@/api/appController";
import { IconPlus } from "@arco-design/web-vue/es/icon";
import API from "@/api";
import AIGenerateQuestionDrawer from "@/views/app/components/AIGenerateQuestionDrawer.vue";
import { getUserRemainingCountUsingPost } from "@/api/userUsageController";

/**
 * 定义组件属性类型
 */
interface Props {
  appId: string;
  appVO: API.AppVO;
}

/**
 * 给组件指定初始值
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'AddAppQuestionModal',
  props: {
    appId: { default: () => "" },
    appVO: { default: () => null }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const visible = ref(false);

const openModal = () => {
  loadData();
  getRemainingCount();
  visible.value = true;
  handleTabClick(1);
};

const closeModal = () => {
  tabsData.value = [];
  visible.value = false;
};

__expose({
  openModal,
});

const tabActiveKey = ref(1);
const questionOptionData = ref<API.AppQuestionOptionUpdateDTO[]>([]);
const tabsData = ref([]);

/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  const res = await getAppQuestionAndOptionUsingGet({
    appId: props.appId as any,
  });
  if (res.data.code === 200 && res.data.data) {
    questionOptionData.value = res.data
      .data as API.AppQuestionOptionUpdateDTO[];
    tabsData.value = [];
    if (questionOptionData.value.length <= 0) {
      handleTabsAdd();
      return;
    }
    questionOptionData.value?.forEach((item) => {
      tabsData.value = tabsData.value.concat({
        key: `${tabsData.value.length + 1}`,
        title: `Question ${tabsData.value.length + 1}`,
        data: item,
      } as any);
    });
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

const handleTabClick = (key: any) => {
  tabActiveKey.value = key as number;
};

const handleTabsAdd = () => {
  tabsData.value = tabsData.value.concat({
    key: `${tabsData.value.length + 1}`,
    title: `Question ${tabsData.value.length + 1}`,
    data: {
      question: {
        questionName: "",
        questionPic: "",
      },
      optionList: [
        {
          optionKey: "",
          optionName: "",
          optionResult: "",
        },
      ],
    },
  });
  tabActiveKey.value += 1;
};

const handleTabsDelete = (key: any) => {
  tabActiveKey.value -= 1;
  tabsData.value = tabsData.value.filter((item) => item.key !== key);
  tabsData.value.forEach((item, index) => {
    item.key = index + 1;
    item.title = `Question ${index + 1}`;
  });
};

const handleOptionAdd = (item: API.AppQuestionOptionUpdateDTO) => {
  item.optionList.push({
    optionKey: "",
    optionName: "",
    optionResult: "",
  });
};

const handleOptionDelete = (
  item: API.AppQuestionOptionUpdateDTO,
  index: number
) => {
  item.optionList?.splice(index);
};
/**
 * 提交问题和选项
 */
const submitQuestionOptionData = async () => {
  let data = [] as API.AppQuestionOptionUpdateDTO[];
  tabsData.value.forEach((item) => {
    if (
      item.data.question.questionName === "" ||
      item.data.optionList.length === 0
    ) {
      return;
    }
    data.push(item.data);
  });
  const res = await addAndUpdateAppQuestionAndOptionUsingPost({
    appId: props.appId,
    appQuestionAndOptionList: data,
  });
  if (res.data.code === 200) {
    message.success("提交成功");
    closeModal();
  } else {
    message.error("提交失败，" + res.data.message);
  }
};
// AI 生成题目成功后执行
const onSuccess = (result: API.AppAIGenerateVO[]) => {
  result.forEach((item) => {
    tabsData.value = tabsData.value.concat({
      key: `${tabsData.value.length + 1}`,
      title: `Question ${tabsData.value.length + 1}`,
      data: {
        question: {
          questionName: item.questionName,
          questionPic: "",
        },
        optionList: item.optionList,
      },
    });
  });
  message.success(`AI 生成题目成功，生成 ${result.length} 道题目`);
};

const onSSESuccess = (result: API.AppQuestionOptionUpdateDTO) => {
  tabsData.value = tabsData.value.concat({
    key: `${tabsData.value.length + 1}`,
    title: `Question ${tabsData.value.length + 1}`,
    data: {
      question: {
        questionName: result.questionName,
        questionPic: "",
      },
      optionList: result.optionList,
    },
  });
};

const onSSEStart = () => {
  message.success(`AI 开始生成题目`);
};

const onSSEClose = () => {
  message.success(`AI 生成题目结束`);
};

const remainingCount = ref<number>(0);
/**
 * 获取剩余调用次数
 */
const getRemainingCount = async () => {
  const res = await getUserRemainingCountUsingPost({
    usageType: "app_ai",
  });
  if (res.data.code === 200) {
    remainingCount.value = res.data.data as number;
  } else {
    message.error("获取调用次数失败，" + res.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      onCancel: closeModal,
      footer: false,
      fullscreen: ""
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.appVO.appName), 1)
      ]),
      default: _withCtx(() => [
        (tabsData.value.length > 0)
          ? (_openBlock(), _createBlock(_component_a_tabs, {
              key: 0,
              type: "card",
              editable: true,
              "show-add-button": "",
              class: "tabs",
              "auto-switch": true,
              "default-active-key": "1",
              "active-key": tabActiveKey.value,
              onTabClick: handleTabClick,
              onAdd: handleTabsAdd,
              onDelete: handleTabsDelete
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsData.value, (item) => {
                  return (_openBlock(), _createBlock(_component_a_tab_pane, {
                    key: item.key,
                    title: item.title
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form, {
                        model: item,
                        class: "tabsForm"
                      }, {
                        default: _withCtx(() => [
                          (item.data.question)
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 0,
                                label: "题目标题"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    modelValue: item.data.question.questionName,
                                    "onUpdate:modelValue": ($event: any) => ((item.data.question.questionName) = $event),
                                    placeholder: "请输入题目标题"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data.optionList, (optionItem, optionIndex) => {
                            return (_openBlock(), _createBlock(_component_a_row, {
                              gutter: 30,
                              key: optionIndex
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 4 }),
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "选项Key",
                                      "label-col-flex": "60px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_input, {
                                          modelValue: optionItem.optionKey,
                                          "onUpdate:modelValue": ($event: any) => ((optionItem.optionKey) = $event),
                                          placeholder: "请输入选项Key"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "选项内容",
                                      "label-col-flex": "60px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_input, {
                                          modelValue: optionItem.optionName,
                                          "onUpdate:modelValue": ($event: any) => ((optionItem.optionName) = $event),
                                          placeholder: "请输入选项内容"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "选项结果",
                                      "label-col-flex": "60px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_input, {
                                          modelValue: optionItem.optionResult,
                                          "onUpdate:modelValue": ($event: any) => ((optionItem.optionResult) = $event),
                                          placeholder: "请输入选项结果"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_col, { span: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      status: "danger",
                                      onClick: ($event: any) => (handleOptionDelete(item.data, optionIndex))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("-")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_a_form_item, {
                            field: "questionName",
                            label: "添加选项"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: ($event: any) => (handleOptionAdd(item.data))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_unref(IconPlus))
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["model"])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-key"]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_space, { class: "btn" }, {
          default: _withCtx(() => [
            _createVNode(AIGenerateQuestionDrawer, {
              appId: _ctx.appId,
              "remaining-count": remainingCount.value,
              onSuccess: onSuccess,
              onSSESuccess: onSSESuccess,
              onSSEStart: onSSEStart,
              onSSEClose: onSSEClose,
              onUpdateRemainCount: getRemainingCount
            }, null, 8, ["appId", "remaining-count"]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: submitQuestionOptionData
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 提交 ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              status: "danger",
              onClick: closeModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 取消 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})